import { render, staticRenderFns } from "./PreHomeV2.vue?vue&type=template&id=724c5929&scoped=true"
import script from "./PreHomeV2.vue?vue&type=script&lang=js"
export * from "./PreHomeV2.vue?vue&type=script&lang=js"
import style0 from "./PreHomeV2.vue?vue&type=style&index=0&id=724c5929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c5929",
  null
  
)

export default component.exports